export default __webpack_public_path__ + "static/media/87.9712fcb7.jpg";